import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { dispatch } from '../../../redux'
import { getJdDetailsThunk } from '../../../redux/action/resumeLibraryAction'
import { useSelector } from 'react-redux'
import { Store } from '../../../redux/Actions'
import { monthsToYearsAndMonths } from '../../../util/utils'
import { FormattedMessage } from 'react-intl'

const JdDetailsModal = ({ show, handleClose, attachedJd }) => {
  const jdDetails = useSelector(
    (state: Store) => state?.resumeLibraryReducer?.jdDetails
  )

  useEffect(() => {
    attachedJd?.job_description?.id &&
      dispatch(getJdDetailsThunk(attachedJd?.job_description?.id))
  }, [attachedJd?.job_description?.id])

  return (
    <Modal show={show} className="sideModal" onHide={handleClose}>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="p-4">
        <div className="mb-4 pb-4 border-bottom border-light">
          <div className="d-flex">
            <h5 className="mb-0">{jdDetails?.job_title || '-'}</h5>
            <span className="badge badge-warning min-w-100">
              {jdDetails?.department?.name || '-'}
            </span>
          </div>
          <span className="text-muted d-block">
            {jdDetails?.experience_from
              ? monthsToYearsAndMonths(jdDetails?.experience_from)
              : 0}
            -
            {jdDetails?.experience_to
              ? monthsToYearsAndMonths(jdDetails?.experience_to)
              : 0}{' '}
            Years
          </span>
        </div>
        <h5 className="mb-3">
          <FormattedMessage id="Description" defaultMessage="Description" />
        </h5>
        <p
          className="mb-4 pb-3"
          dangerouslySetInnerHTML={{
            __html: jdDetails?.job_description || 'Description not available',
          }}
        ></p>
        <h5 className="mb-3">Skills and Experience</h5>
        {jdDetails?.skills?.length > 0 ? (
          <ul className="text-black-400 ps-3">
            {jdDetails?.skills?.map((skill) => (
              <li key={skill?.id}>{skill?.skill_name}</li>
            ))}
          </ul>
        ) : (
          '-'
        )}
      </Modal.Body>
    </Modal>
  )
}

export default JdDetailsModal
